import {cityConfig} from "@/components/resume/const/getMenuConfigByField";

export default () => cityConfig
